import {HttpErrorResponse,HttpResponse} from '@angular/common/http';
import {Component,OnInit} from '@angular/core';
import {ActivatedRoute,ParamMap} from '@angular/router';
import * as changeCase from "change-case";
import {JhiAlertService} from 'ng-jhipster';
import {Observable} from 'rxjs';
import {Principal,User} from 'src/app/core';
import {NotificationEventTrigger} from 'src/app/core/user/notification-event-trigger.model';
import {NotificateType} from 'src/app/shared/model/notification-type';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {NotificationEventTriggerByGroup} from './../../core/user/notification-event-trigger.model';
import {NotificationPreferenceService} from './notification-preference.service';

import {environment} from 'src/environments/environment';
import { TypeOfClient } from 'src/app/shared/model/client.model';
import { CommonUtils } from 'src/app/shared/util/common-utils';
@Component({
    selector: 'jhi-notification-preference-update',
    templateUrl: './notification-preference-my-suffix-update.component.html',
    styles: []
})
export class NotificationPreferenceComponent implements OnInit {
    _notificationEventTrigger: NotificationEventTrigger[] = [];
    userId: number;
    mailSelectAllModel: boolean;
    smsSelectAllModel: boolean;
    notificationSelectAllModel: boolean;
    mailSelectedList = [];
    notificationSelectedList = [];
    smsSelectedList = [];

    notificationEventTriggerByGroup: NotificationEventTriggerByGroup[] = [];
    notificationEventTriggerSorted = [];
    selectedClient=environment.login
    constructor(
        private activatedRoute: ActivatedRoute,
        private jhiAlertService: JhiAlertService,
        private notificationPreferenceService: NotificationPreferenceService,
        private languageChangeService: LanguageChangeService,
        private principal: Principal

    ) {
        this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
                window.history.back();
            }
    });
    }

    ngOnInit() {
        this.userId = this.activatedRoute.snapshot.params['id'];

        this.activatedRoute.data.subscribe(({ notificationPreferenceDetail }) => {
            this.notificationEventTriggerByGroup = notificationPreferenceDetail;

            console.log(notificationPreferenceDetail[NotificateType.DELEGATIONS]);
            
            this.notificationEventTriggerSorted.push([NotificateType.CERTIFICATE_REQUEST, this.notificationEventTriggerByGroup[NotificateType.CERTIFICATE_REQUEST]]);
            this.notificationEventTriggerSorted.push([NotificateType.CERTIFICATE, this.notificationEventTriggerByGroup[NotificateType.CERTIFICATE]]);
            this.notificationEventTriggerSorted.push([NotificateType.LOSS_PAYEE, this.notificationEventTriggerByGroup[NotificateType.LOSSPAYEE]]);
            if (this.principal.userIdentity.authorities[0] === "BROKER" || this.principal.userIdentity.authorities[0] === "BROKER_STAFF" || this.principal.userIdentity.authorities[0] === "UNDERWRITER" || this.principal.userIdentity.authorities[0] === "UNDERWRITER_STAFF") {
                this.notificationEventTriggerSorted.push([NotificateType.DELEGATIONS, this.notificationEventTriggerByGroup[NotificateType.DELEGATIONS]]);
            }
            if (this.principal.userIdentity && (this.principal.userIdentity.typeOfClient != TypeOfClient.FREIGHT_FORWARDER)) {
                this.notificationEventTriggerSorted.push([NotificateType.STORAGE, this.notificationEventTriggerByGroup[NotificateType.STORAGE]]);
            }
            if (this.principal.userIdentity && (this.principal.userIdentity.typeOfClient == TypeOfClient.FREIGHT_FORWARDER
                    || this.principal.userIdentity.typeOfClient == TypeOfClient.TRADER)) {
                if (CommonUtils.isNotNil(this.notificationEventTriggerByGroup[NotificateType.ACCOUNTING])) {
                    this.notificationEventTriggerSorted.push([NotificateType.ACCOUNTING, this.notificationEventTriggerByGroup[NotificateType.ACCOUNTING]]);
                }
            }

            let isAdminUsers=this.principal.userIdentity && (this.principal.userIdentity.authorities[ 0 ]==="BROKER"|| this.principal.userIdentity.authorities[ 0 ]==="BROKER_STAFF"||
            this.principal.userIdentity.authorities[ 0 ]==="INSURER"|| this.principal.userIdentity.authorities[ 0 ]==="INSURER_STAFF"||
            this.principal.userIdentity.authorities[ 0 ]==="UNDERWRITER"|| this.principal.userIdentity.authorities[ 0 ]==="UNDERWRITER_STAFF");
    
            if(isAdminUsers && this.principal.userIdentity.enableAccounting && this.principal.userIdentity.enablePremiumCalculation){
                this.notificationEventTriggerSorted.push([NotificateType.ACCOUNTING,this.notificationEventTriggerByGroup[NotificateType.ACCOUNTING]]);
            }

            if(isAdminUsers && this.principal.checkForEnableSanctionScreening()) {
                this.notificationEventTriggerSorted.push([ NotificateType.FINSCAN,this.notificationEventTriggerByGroup[ NotificateType.FINSCAN ] ]);  
            }

            this.notificationEventTriggerSorted.push([NotificateType.POLICY_RENEWAL, this.notificationEventTriggerByGroup[NotificateType.POLICY_RENEWAL]]);

            // Object.keys(notificationPreferenceDetail).forEach(noti => {
            //     this.notificationEventTriggerByGroup[noti].forEach((item: NotificationEventTrigger) => this.notificationEventTrigger.push(item));
            // });
            
            const newObj = this.structureNotifications(this.notificationEventTriggerSorted);

            Object.keys(newObj).forEach(noti => {
                newObj[noti].forEach((item: NotificationEventTrigger) => this.notificationEventTrigger.push(item));
            });


            // for select all checkboxes make as checked
            this.notificationEventTriggerSorted.forEach((it: any) => {
                it[1].forEach((item: NotificationEventTrigger) => {
                    //for Notification select all checkbox
                    if (item.notificationPreference.sms) {
                        this.smsSelectedList.push(item);
                        // if the selected array is equal to notification preference list we make SMSSelectAll checkbox as Checked
                        if (this.smsSelectedList.length == this.notificationEventTrigger.length) {
                            this.smsSelectAllModel = true;
                        } else {
                            this.smsSelectAllModel = false;
                        }
                    }
                    // for mail Select all checkbox
                    if (item.notificationPreference.mail) {
                        this.mailSelectedList.push(item);
                        // if the selected array is equal to notification preference list we make MailSelectAll checkbox as Checked
                        if (this.mailSelectedList.length == this.notificationEventTrigger.length) {
                            this.mailSelectAllModel = true;
                        } else {
                            this.mailSelectAllModel = false;
                        }
                    }
                    // for notification select all checkbox
                    if (item.notificationPreference.notification) {
                        this.notificationSelectedList.push(item);
                        // if the selected array is equal to notification preference list we make notificationSelectAll checkbox as Checked
                        if (this.notificationSelectedList.length == this.notificationEventTrigger.length) {
                            this.notificationSelectAllModel = true;
                        } else {
                            this.notificationSelectAllModel = false;
                        }
                    }
                })
            });
        });
    }
    set notificationEventTrigger(notificationEventTrigger: NotificationEventTrigger[]) {
        this._notificationEventTrigger = notificationEventTrigger;
    }

    get notificationEventTrigger() {
        return this._notificationEventTrigger;
    }

    save() {
        let user = new User();
        user.id = this.userId;
        let triggerPoints: NotificationEventTrigger[] = [];
        this.notificationEventTriggerSorted.forEach(it => {
            it[1].forEach(item => {
                triggerPoints.push(item);
            });
        });
        user.notificationEventTrigger = triggerPoints;
        this.subscribeToSaveResponse(this.notificationPreferenceService.update(user));
    }
    previousState() {
        window.history.back();
    }

    //Mail Select all checkbox event
    mailSelectAll(event) {
        if (event.target.checked) {

            this.notificationEventTriggerSorted.forEach(it => {
                it[1].forEach(item => {
                    item.notificationPreference.mail = true;
                })
            });
            this.mailSelectedList = [...this.notificationEventTrigger]
        } else {
            this.notificationEventTriggerSorted.forEach(it => {
                it[1].forEach(item => {
                    item.notificationPreference.mail = false;
                })
            });
            this.mailSelectedList = [];
        }
        console.log(this.notificationEventTrigger, "this.notificationEventTrigger");
    }


    //Notification Select all checkbox event
    notificationSelectAll(event) {
        if (event.target.checked) {

            this.notificationEventTriggerSorted.forEach(it => {
                it[1].forEach(item => {
                    item.notificationPreference.notification = true;
                })
            });
            this.notificationSelectedList = [...this.notificationEventTrigger]
        } else {
            this.notificationEventTriggerSorted.forEach(it => {
                it[1].forEach(item => {
                    item.notificationPreference.notification = false;
                })
            });
            this.notificationSelectedList = [];
        }
        console.log(this.notificationEventTrigger, "this.notificationEventTrigger");
    }


    //SMS Select all checkbox event
    smsSelectAll(event) {
        if (event.target.checked) {

            this.notificationEventTriggerSorted.forEach(it => {
                it[1].forEach(item => {
                    item.notificationPreference.sms = true;
                })
            });
            this.mailSelectedList = [...this.notificationEventTrigger]
        } else {
            this.notificationEventTriggerSorted.forEach(it => {
                it[1].forEach(item => {
                    item.notificationPreference.sms = false;
                })
            });
            this.mailSelectedList = [];
        }
        console.log(this.notificationEventTrigger, "this.notificationEventTrigger");
    }



    // Mail checkbox as checked or unchecked based on the no of items checked
    mailSelectChangeEvent(checked, data) {
        // for every change of mail checkbox event we are checking whether all checkboxes or selected or not
        let findIndex = this.mailSelectedList.findIndex(item => item.id == data.id);
        if (checked) {
            if (findIndex == -1) {
                this.mailSelectedList.push(data)
            }
        } else {

            if (findIndex > -1) {
                this.mailSelectedList.splice(findIndex, 1)
            }
        }
        // if the selected array is equal to notification preference list we make MailSelectAll checkbox as Checked
        if (this.mailSelectedList.length == this.notificationEventTrigger.length) {
            this.mailSelectAllModel = true;
        } else {
            this.mailSelectAllModel = false;
        }
    }

    // Notification checkbox as checked or unchecked based on the no of items checked
    notificationChangeEvent(checked, data) {
        // for every change of mail checkbox event we are checking whether all checkboxes or selected or not
        let findIndex = this.notificationSelectedList.findIndex(item => item.id == data.id);
        if (checked) {
            if (findIndex == -1) {
                this.notificationSelectedList.push(data)
            }
        } else {

            if (findIndex > -1) {
                this.notificationSelectedList.splice(findIndex, 1)
            }
        }
        // if the selected array is equal to notification preference list we make MailSelectAll checkbox as Checked
        if (this.notificationSelectedList.length == this.notificationEventTrigger.length) {
            this.notificationSelectAllModel = true;
        } else {
            this.notificationSelectAllModel = false;
        }
    }

    // SMS checkbox as checked or unchecked based on the no of items checked
    smsChangeEvent(checked, data) {
        // for every change of mail checkbox event we are checking whether all checkboxes or selected or not
        let findIndex = this.smsSelectedList.findIndex(item => item.id == data.id);
        if (checked) {
            if (findIndex == -1) {
                this.smsSelectedList.push(data);
            }
        } else {

            if (findIndex > -1) {
                this.smsSelectedList.splice(findIndex, 1)
            }
        }
        // if the selected array is equal to notification preference list we make MailSelectAll checkbox as Checked
        if (this.smsSelectedList.length == this.notificationEventTrigger.length) {
            this.smsSelectAllModel = true;
        } else {
            this.smsSelectAllModel = false;
        }
    }

    private subscribeToSaveResponse(result: Observable<HttpResponse<any>>) {
        result.subscribe(
            (res: HttpResponse<any>) => this.onSaveSuccess(),
            (res: HttpErrorResponse) => this.onError(res.message)
        );
    }

    private onSaveSuccess() {
        this.previousState();
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }


    getTriggerPoint(triggerPoint: any) {
        return changeCase.capitalCase(triggerPoint);
    }

    structureNotifications(data) {
        // Initialize an empty object to hold the structured data
        let structuredData = {};
    
        // Iterate over the input data
        data.forEach((item) => {
            // The first element is the key
            const key = item[0];
            // The second element is the array of notifications
            const notifications = item[1];
    
            // Assign the notifications array to the key in the structured data object
            structuredData[key] = notifications;
        });
    
        return structuredData;
    }
    
    
    

}